import { getBrandName } from '../brand-name';

export function getAndroidApk() {
  const brandName = getBrandName();
  // ToDo: https://jira.tennisi.it/browse/CP-2523
  switch (brandName) {
    case 'tennisi':
      return 'https://apk.tennisi.pro/tennisi-pro-latest.apk';
    case 'chesnok':
      return 'https://apk.chesnok.bet/chesnok-bet-latest.apk';
    // TODO: KOMYOB
    case 'komyob':
      return 'https://apk.chesnok.bet/chesnok-bet-latest.apk';
    default:
      assertExhaustiveness(brandName);
  }
}
